import React from "react"
import { Button, Header, Flex, Divider, Text } from "@jjordy/layout"
import { Link, RouteComponentProps } from "@reach/router"

const quotes = [
  "These are not the droids your looking for.",
  "What we've got here is a failure to communicate",
  "Great Scott!!! this page has been erased from existence!",
  "Word on the street is this page is never coming back!"
]

const getRandomItemFromArray = (arr: any[]) => {
  return arr[Math.floor(Math.random() * arr.length)]
}

export interface NotFoundRouteProps extends RouteComponentProps {
  [s: string]: any
}

const NotFound: React.SFC<NotFoundRouteProps> = () => (
  <React.Fragment>
    <Flex justify="center" align="center" direction="column">
      <div>
        <Header fg="red" textAlign="center">
          404 Page Not Found
        </Header>
        <Divider />
        <Text fg="grey" textAlign="center">
          {getRandomItemFromArray(quotes)}
        </Text>
      </div>
      <Button as={Link} to="/">
        GO HOME
      </Button>
    </Flex>
  </React.Fragment>
)

export default NotFound
